import DateCell from "@components/ReactTable/DateCell";
import CodeDaysCell from "../components/CodeDaysCell";
import DescriptionCell from "@components/ReactTable/DescriptionCell";
import { Row } from "react-table";
import CodeEventTableActions from "../components/ItemTableActions";
export const codeEventTableData = () => ({
  header: [
    {
      Header: "Actions",
      id: "expander", // It needs an ID
      Cell: ({ row }: { row: Row }) => (
        <CodeEventTableActions {...row.getToggleRowExpandedProps()} row={row} />
      ),
    },
    {
      Header: "Code Value",
      accessor: "codeDecString",
    },
    {
      Header: "Code Days",
      accessor: "codeDays",
      Cell: CodeDaysCell,
    },
    {
      Header: "Code Type",
      accessor: "codeType",
    },
    {
      Header: "hashIndex",
      accessor: "hashIndex",
    },
    {
      Header: "hashTop",
      accessor: "hashTop",
    },
    {
      Header: "hashRoot",
      accessor: "hashRoot",
    },
    {
      Header: "codeCount",
      accessor: "codeCount",
    },
    {
      Header: "Code Number",
      accessor: "codeNumber",
    },
    {
      Header: "Triggers",
      accessor: "triggers",
      Cell: DescriptionCell,
    },

    {
      Header: "userWhoCausedTheChange",
      accessor: "userWhoCausedTheChange",
      Cell: DescriptionCell,
    },
    {
      Header: "typeOfChangeChange",
      accessor: "typeOfChangeChange",
      Cell: DescriptionCell,
    },
    {
      Header: "typeOfChangeChange",
      accessor: "descriptionOfChangeChange",
      Cell: DescriptionCell,
    },
    {
      Header: "ID",
      accessor: "_id",
    },
    {
      Header: "Date Created",
      accessor: "createdAt",
      Cell: DateCell,
    },
  ],
});

// Define custom columns for OpenToken data
export const openTokenColumns = [
  {
    Header: "Actions",
    id: "expander", // It needs an ID
    Cell: ({ row }: { row: Row }) => (
      <CodeEventTableActions {...row.getToggleRowExpandedProps()} row={row} />
    ),
  },
  {
    Header: "ID",
    accessor: "_id",
    width: 50,
  },
  {
    Header: "Type",
    accessor: "type",
  },
  {
    Header: "Action Scope",
    accessor: "actionScope",
  },
  {
    Header: "Actor Name",
    accessor: "actorName",
  },
  {
    Header: "Profile",
    accessor: "profile",
  },
  {
    Header: "Token",
    accessor: "token",
  },
  {
    Header: "Token Type",
    accessor: "token_type",
  },
  {
    Header: "Max Count",
    accessor: "max_count",
  },
  {
    Header: "History Type",
    accessor: "code_history_type",
  },
  {
    Header: "Token Value",
    accessor: "token_value",
  },
  {
    Header: "Created At",
    accessor: "createdAt",
    Cell: DateCell,
  },
  {
    Header: "Updated At",
    accessor: "updatedAt",
    Cell: DateCell,
  },
];
